import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
    });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children ?? <div />}
        </Slide>
    );
}

HideOnScroll.propTypes = {
    children: PropTypes.element,
    window: PropTypes.func,
};

function NavBar() {
    const navigate = useNavigate(); // Initialize useNavigate

    // Function to handle logout
    const handleLogout = () => {
        localStorage.removeItem('isLoggedIn'); // Clear login status
        navigate('/'); // Redirect to the login page
    };

    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'; // Check login status

    return (
        <React.Fragment>
            <CssBaseline />
            <HideOnScroll>
                <AppBar sx={{ backgroundColor: 'white', color: 'Black', fontFamily: 'asdf' }}>
                    <Toolbar>
                        <a href='/' style={{ color: "Black", textDecoration: 'none' }}>
                            <Typography variant="h6" component="div">
                                M.M.MUNIDASA LOTTERY AGENCY
                            </Typography>
                        </a>
                        {isLoggedIn && ( // Show logout button if logged in
                            <Button color="inherit" onClick={handleLogout} sx={{ marginLeft: 'auto' }}>
                                Logout
                            </Button>
                        )}
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
            <Toolbar />
        </React.Fragment>
    );
}

export default NavBar;
